import AttributesPercentageField from './AttributesPercentageField'

export default AttributesPercentageField
